<template>
    <div class="row">
    <div class="col-xxl-2 col-xl-3 border-end border-end-xl">
        <aside class="sidebar sticky-lg-top sticky-pernet">
            <a href="#" class="btn w-100 btn-secondary fw-bold mb-2">Affiner votre recherche</a>
            <button type="reset" class="btn w-100 btn-default"><i class="fas fa-times small"></i> Réinitialiser les filtres</button>

            <div class="filters">
                <ul class="list-unstyled">
                    <li>
                 <span class="w-100 border-bottom d-block pb-1 pt-3 text-uppercase fw-bold show" data-bs-toggle="collapse" href="#promo" role="button" aria-expanded="true" aria-controls="promo">
                     <span class="badge badge-pill bg-secondary"><i class="fas fa-plus"></i></span>
                     Promos / Nouveautés
                 </span>
                        <ul class="collapse list-unstyled show" id="promo">
                            <li>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="promotions">
                                    <label class="form-check-label" for="promotions">
                                        Promotions
                                    </label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="nouveautes">
                                    <label class="form-check-label" for="nouveautes">
                                        Nouveautés
                                    </label>
                                </div>
                            </li>
                        </ul>
                        <span class="w-100 border-bottom d-block pb-1 pt-3 text-uppercase fw-bold show" data-bs-toggle="collapse" href="#categories" role="button" aria-expanded="true" aria-controls="categories">
                     <span class="badge badge-pill bg-secondary"><i class="fas fa-plus"></i></span>
                     Catégories
                 </span>
                        <ul class="collapse list-unstyled" id="categories" v-for="(category, index) in categories">
                            <li>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox"  :value="category.id"  :id="'category'+index" v-model="selected.categories">
                                    <label class="form-check-label" :for="'category' + index">
                                        {{ category.name }}
                                    </label>
                                </div>
                            </li>
                        </ul>

                        <span class="w-100 border-bottom d-block pb-1 pt-3 text-uppercase fw-bold show" data-bs-toggle="collapse" href="#packagings"
                              role="button" aria-expanded="true" aria-controls="packagings">
                     <span class="badge badge-pill bg-secondary"><i class="fas fa-plus"></i></span>
                     Conditionnement
                 </span>
                        <ul class="collapse list-unstyled" id="packagings" v-for="(packaging, index) in packagings">
                            <li>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox"  :value="packaging.code"  :id="'packaging'+index" v-model="selected.packagings">
                                    <label class="form-check-label" :for="'packaging' + index">
                                        {{ packaging.label }}
                                    </label>
                                </div>
                            </li>
                        </ul>

                    </li>
                </ul>
            </div>
        </aside>
    </div>

    <div class="col-xxl-10 col-xl-9">

        <div class="heading_catalogue mb-4">
            <h1 class="h3 fw-bold">Promotions</h1>
            <hr>
        </div>
    <div :class="{'loading': loading}">
        <div class="products row" >

            <shop-item v-for="item in products" :item="item" :key="item.id">
            </shop-item>
  </div>
    </div>
    </div>
    </div>
</template>

<script>
    export default {
        name: 'Product-Promotion',
        props: ['user_id'],
        data: function () {
            return {
                loading: true,
                products: [],
                categories: [],
                packagings: [],
                promotions: true,
                nouveautes: false,
                selected: {
                    categories: [],
                    packagings: [],
                }
            }
        },
        mounted() {
            this.loadProducts();
            this.loadPackaging();
            this.loadCategories();
        },
        created() {

        },
        methods: {
            loadProducts: function() {
                axios.get('/api/search-promotions', {
                    params: {
                        promotions: this.promotions,
                        user_id : this.user_id
                    }
                })
                    .then((response) => {
                        this.products = response.data.data;
                        this.loading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            loadCategories: function() {
                axios.get('/api/categories', {
                })
                    .then((response) => {
                        this.categories = response.data.data;
                        this.loading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            loadPackaging: function() {
                axios.get('/api/packaging', {
                })
                    .then((response) => {
                        this.packagings = response.data.data;
                        this.loading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            resetFilters()
            {
                this.selected.packagings = [];
                this.selected.categories = [];
                this.selected.nouveautes = false;
                this.selected.promotions = false;
            }
        }
    }
</script>
